import {
  Button,
  ConfigProvider,
  Form,
  Input,
  Modal,
  Pagination,
  Select,
  Table,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Alertify from "../../../services/alertify";
import {
  GenerateQrCode,
  GetQrCodesList,
} from "../../../redux/actions/qrCodes/qrCodes-action";
import PrintSingleQrCode from "./print-single-qr-code";
import { LoaderIcon } from "react-hot-toast";
import PrintBulkFunction from "./print-bulk-function";
import ExcelUpload from "./excel-upload";

const { Title } = Typography;
const QRCodesListWest = () => {
  const [dataSource, setDataSource] = useState([]);
  const dispatch = useDispatch();
  const [form] = Form.useForm(); // Use Form.useForm() directly from antd
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [qrModal, setQrModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const columns = [
    {
      title: "Sr. No.",
      key: "index",
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    { title: "QR Id", dataIndex: "qrId", key: "qrId" },
    {
      title: "PPF Roll Number",
      dataIndex: "ppfRollNumber",
      key: "ppfRollNumber",
    },
    {
      title: "Variant",
      dataIndex: "variant",
      key: "variant",
      align: "center",
    },
    { title: "Date", dataIndex: "date", key: "applicationDate" },
    { title: "Time", dataIndex: "time", key: "totalSqftUsed" },
    {
      title: "Action",
      dataIndex: "",
      key: "action",
      align: "center",
      render: (record) => (
        <PrintSingleQrCode ppfRollNumber={record.ppfRollNumber} size={200} />
      ),
    },
  ];

  const { handlePrintBulk } = PrintBulkFunction({
    selectedRows,
    setLoading,
  });

  const fetchQrCodesList = (page, pageSize, search) => {
    dispatch(GetQrCodesList({ page, limit: pageSize, region: "West", search }))
      .then((response) => {
        const data = response?.payload?.data?.data || [];
        const dataWithKeys = data.map((item, index) => ({
          ...item,
          key: item.qrId || `warranty-${index}`,
        }));
        setPagination((prevPagination) => ({
          ...prevPagination,
          total: response?.payload?.data?.total,
        }));
        setDataSource(dataWithKeys);
      })
      .catch((error) => {
        Alertify.error("Error fetching QR Code list. Please try again.");
      });
  };

  useEffect(() => {
    fetchQrCodesList(pagination.current, pagination.pageSize, searchText ?? "");
  }, [dispatch, setDataSource, pagination.current, searchText]);

  const generateQrCode = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      // console.log("Form Values:", values);
      const formData = {
        ppfRollNumber: values.ppfRollNumber,
        variant: values.variant,
        region: values.region,
        sqft: values.sqft,
        size: 150,
      };
      dispatch(GenerateQrCode(formData)).then((response) => {
        // console.log(response);
        if (
          response.error ||
          (response.payload && response.payload.statusCode >= 400)
        ) {
          const errorMessage =
            response.payload?.message ||
            "Error generating QR code. Please ensure PPF Roll Number is valid.";
          Alertify.error(errorMessage);
        } else {
          Alertify.success("QR Code generated successfully");
          fetchQrCodesList(pagination.current, pagination.pageSize, "");
          setQrModal(false);
          setLoading(false);
        }
        form.resetFields();
      });
    } catch (error) {
      console.error("Validation Failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            borderRadiusLG: 8,
          },
          Form: {
            itemMarginBottom: 0,
          },
          Typography: {
            titleMarginBottom: 0,
          },
        },
      }}
    >
      <div className="flex justify-between p-4 itmes-center">
        <Title level={2} className="text-start">
          QR Codes
        </Title>
        <Input.Search
          // value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Search PPF Roll Number"
          style={{ width: 200, marginBottom: 0, height: 35 }}
        />
        <div className="flex items-center gap-4">
          <Button
            type="primary"
            className="rounded-md"
            onClick={handlePrintBulk}
            disabled={selectedRows.length === 0}
          >
            Print Bulk
          </Button>
          <Button
            type="primary"
            className="rounded-md"
            onClick={() => setQrModal(true)}
          >
            + New Qr Code
          </Button>
        </div>
      </div>
      <Table
        rowSelection={{
          type: "checkbox",
          selectedRowKeys: selectedRowKeys,
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
            setSelectedRows(selectedRows);
          },
        }}
        className="rounded-lg"
        columns={columns}
        dataSource={dataSource}
        size="middle"
        loading={loading}
        pagination={false}
        bordered
      />
      <Pagination
        className="mt-4"
        align="center"
        current={pagination.current}
        pageSize={pagination.pageSize}
        total={pagination.total}
        onChange={(page, pageSize) => {
          setPagination((prevPagination) => ({
            ...prevPagination,
            current: page,
            pageSize,
          }));
        }}
        // hideOnSinglePage
      />
      <Modal
        open={qrModal}
        className="rounded-lg"
        centered
        onCancel={() => setQrModal(false)}
        footer={false}
      >
        <Title level={3} className="text-center">
          Generate QR Code
        </Title>
        <Form
          form={form}
          layout="horizontal"
          className="flex flex-col items-center justify-center gap-2 py-4 text-center border-t border-b"
        >
          {/* <Text></Text> */}
          <Form.Item
            label="PPF Roll Number"
            name="ppfRollNumber"
            className="w-2/3"
            rules={[{ required: true, message: "PPF Roll Number is required" }]}
          >
            <Input plceholder="PPF Roll Number" maxLength={20} />
          </Form.Item>
          <Form.Item
            label="Variant"
            name="variant"
            className="w-2/3"
            rules={[{ required: true, message: "Select Variant" }]}
          >
            <Select
              placeholder="Select Variant"
              options={[
                {
                  value: "Ranger",
                  label: "Ranger",
                },
                {
                  value: "Armor",
                  label: "Armor",
                },
                {
                  value: "Defender",
                  label: "Defender",
                },
                {
                  value: "Ranger Matte",
                  label: "Ranger Matte",
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            label="Region"
            name="region"
            initialValue="West"
            className="w-2/3"
            rules={[{ required: true, message: "Select Variant" }]}
          >
            <Select
              placeholder="Select Region"
              disabled
              options={[
                {
                  value: "NCR",
                  label: "NCR",
                },
                {
                  value: "North",
                  label: "North",
                },
                {
                  value: "West",
                  label: "West",
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            label="Total SqFt"
            name="sqft"
            className="w-2/3"
            rules={[
              { required: true, message: "Total SqFt is required" },
              {
                validator: (_, value) => {
                  if (value > 999) {
                    return Promise.reject("Max value allowed is 999");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input type="number" max={999} />
          </Form.Item>
          <div className="flex justify-start mt-4">
            <button
              className="mr-2 px-4 py-2 bg-blue-500 text-white rounded-md w-[100px]"
              onClick={generateQrCode}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <LoaderIcon />
                </div>
              ) : (
                "Save"
              )}
            </button>
            <button
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md w-[100px]"
              onClick={() => setQrModal(false)}
            >
              Cancel
            </button>
          </div>
        </Form>
        <ExcelUpload
          region="West"
          setQrModal={setQrModal}
          setPagination={setPagination}
          setDataSource={setDataSource}
        />
      </Modal>
    </ConfigProvider>
  );
};

export default QRCodesListWest;
